import React from 'react';
import SignIn from '../components/Signin';
import scrollToTop from '../components/ScrollToTop';

const SigninPage = () => {
  return (<>
    <scrollToTop />
    <SignIn />
  </>

  )
}

export default SigninPage;